export const environment = {
  production: false,
  companyName: 'Pueblo Bonito',
  apiUrl: "https://devappadmin.pueblobonito.com.mx:8443/administrador-contenido/"
  // apiUrl: "http://localhost:8080/administrador-contenido/"
};
